import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  List, ListItem, Fade, Alert, AlertTitle,
} from '@mui/material';

import { CloseOutlined as CloseOutlinedIcon } from '@mui/icons-material';

export const ErrorContainer = styled(Alert)`
  text-transform: uppercase;
  ul {
    padding-top: 0;
    padding-bottom: 0;
    li {
      text-decoration: underline;
    }
  }
`;

interface IProps {
  errors: Array<string>;
}

const ValidationError: React.FC<IProps> = (props: IProps) => {
  const [errors, setErrors] = useState(props.errors);
  useEffect(() => setErrors(props.errors), [props.errors]);

  return (
    <ErrorContainer severity="error">
      <AlertTitle>Validation Error</AlertTitle>
      <List>
        {errors.map((error, index) => (
          <ListItem key={index}>
            <CloseOutlinedIcon />
            <Fade in>
              <span>{error}</span>
            </Fade>
          </ListItem>
        ))}
      </List>
    </ErrorContainer>
  );
};

export default ValidationError;
